import React from 'react';
import { useSelector } from 'react-redux';
import { defineMessages, IntlProvider } from 'react-intl';
import { StoreMessageSelector } from '../utils/StoreMessageSelector';

export const IntlProviderWrapper = ({ children }) => {
  const { userLocale, storeId } = useSelector((state) => state.config);

  return (
    <IntlProvider
      locale={userLocale}
      messages={defineMessages(StoreMessageSelector(storeId)[userLocale])}
      defaultLocale={'en-GB'}
      key={userLocale}
    >
      {children}
    </IntlProvider>
  );
};
